import { render, staticRenderFns } from "./GtmClient.vue?vue&type=template&id=32220a5f"
import script from "./GtmClient.vue?vue&type=script&lang=js"
export * from "./GtmClient.vue?vue&type=script&lang=js"
import style0 from "./GtmClient.vue?vue&type=style&index=0&id=32220a5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.23_cache-loader@4.1.0_webpack@4.47.0_webpack-cli@3.3_rzr6sqiw3iaxcjpfollk37er5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports